/* src/app/module/profile/profile.component.scss */
.settings-header {
  padding-bottom: 1rem;
  margin-left: 250px;
  padding: 32px;
}
.settings-header h1 {
  font-size: 24px;
  font-style: normal;
  font-weight: 500;
  line-height: 32px;
  margin: 0;
  margin-bottom: 24px;
  color: #101828;
}
h2 {
  font-size: 1.5rem;
  font-weight: bold;
  margin-bottom: 0.5rem;
}
.personal-info h3 {
  font-size: 18px;
  margin-bottom: 0px;
  margin-top: 32px;
  line-height: 28px;
}
.personal-info p {
  font-size: 14px;
  color: #6c757d;
  font-style: normal;
  font-weight: 400;
  line-height: 20px;
  margin: 0px;
}
.form-row {
  display: flex;
  gap: 1rem;
}
.form-col {
  flex: 1;
}
::ng-deep .field {
  margin-left: 2px;
  margin-bottom: 0px;
  margin-top: 9px;
  margin-right: 15px;
}
::ng-deep .horizontal-line {
  border-top: 1px solid #d1d5db;
  margin: 20px 0;
}
.upload-photo {
  margin-top: 1rem;
}
.button-group {
  display: flex;
  justify-content: flex-start;
  gap: 1rem;
  margin-top: 32px;
  margin-left: 160px;
}
.save-button {
  border-radius: 5px;
  padding: 0.5rem 1.5rem;
}
.cancel-button {
  background-color: #fff;
  color: #000000;
  border-radius: 8px;
  padding: 0.6rem 1.5rem;
  border: 1px solid #D0D5DD;
  height: 40px;
}
.cancel-button:hover {
  transform: translateY(-2px);
  box-shadow: 0 4px 10px rgba(0, 0, 0, 0.1);
}
.p-tabview-nav {
  border-bottom: 2px solid #eaeaea;
}
::ng-deep .p-tabview .p-tabview-nav li.p-highlight .p-tabview-nav-link {
  background: #ffffff;
  border-color: #D47500;
  color: #D47500;
  padding: 20px 6px 20px 6px;
  margin-right: 16px;
}
::ng-deep .p-tabview .p-tabview-nav a {
  padding: 20px 6px 20px 6px;
}
.p-tabview-title {
  font-weight: bold;
  color: #333333;
}
.p-tabview-title.p-highlight {
  color: #ffa000;
}
.custom-hr {
  border: none;
  border-top: 1px solid #d1d5db;
  margin: 20px 0;
}
.horizontal-line {
  border-top: 1px solid #d1d5db;
  margin: 1rem 0;
}
::ng-deep .p-tabview .p-tabview-panels {
  padding: 0px;
}
::ng-deep .p-tabview .p-tabview-nav a:hover {
  border-color: #E4E7EC;
}
::ng-deep .p-inputtext,
::ng-deep .p-dropdown {
  width: 360px !important;
  height: 44px !important;
}
::ng-deep .field1 {
  margin-left: 6px;
}
::ng-deep .p-error {
  margin-top: 4px;
  display: flex;
}
/*# sourceMappingURL=profile.component-B3YDDK7F.css.map */
